<template>
  <div id="contenedor-editar-deduccion">
    <v-form
      v-model="formularioValido"
      ref="editarDeduccion">
      <v-card>
        <v-card-title class="secondary--text">
          Editar deducción
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <custom-text-field
              v-model="deduccion.nombre"
              label="Nombre"
              :rules="[mixReglas.requerido]">
            </custom-text-field>
            <custom-text-field
              v-model.number="deduccion.porcentaje"
              label="Porcentaje"
              type="number"
              suffix="%"
              :rules="[mixReglas.requerido]">
            </custom-text-field>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarDeduccion"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoDeducciones from './mixCatalogoDeducciones';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EditarDeduccion',
  mixins: [mixCatalogoDeducciones],
  props: {
    deduccionEditar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomTextField,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      deduccion: {
        nombre: this.deduccionEditar.nombre,
        porcentaje: this.deduccionEditar.porcentaje,
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.editarDeduccion.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">

</style>
